import axios from 'axios';
import dayjs from 'dayjs';
import jwtDecode from 'jwt-decode';
import { baseUrl } from '../constants/urls';
import { getLocalStorageToken, logoutHandler } from 'utils/auth-utils';
const axiosInstance = axios.create({ baseUrl });

class AsyncLock {
  constructor() {
    this.isLocked = false;

    this.disable = () => {};
    this.promise = Promise.resolve();
  }

  enable() {
    this.promise = new Promise((resolve) => (this.disable = resolve));
    this.promise.then(() => {
      this.isLocked = false;
    });

    this.isLocked = true;
  }
}

// Create a new lock
export const lock = new AsyncLock();

async function requestForRefresh(req) {
  try {
    const data = {
      expiredAccessToken: getLocalStorageToken(),
      refreshToken: `${localStorage.getItem('refreshToken')}`
    };
    const response = await axios.post(`${baseUrl}/api/User/RefreshToken`, data);
    if (response.status === 200)
      localStorage.setItem('token', response.data.token.accessToken);
    req.headers.Authorization = `Bearer ${response.data.token.accessToken}`;
  } catch (err) {}
}

axiosInstance.interceptors.request.use(
  async (req) => {
    if (lock.isLocked) await lock.promise;

    lock.enable();

    req.headers.Authorization = `Bearer ${getLocalStorageToken()}`;
    const user = jwtDecode(getLocalStorageToken());
    const isExpired = dayjs.unix(user?.exp).diff(dayjs()) / 1000 < 21;
    if (isExpired) {
      try {
        await requestForRefresh(req);
      } catch (error) {
        if (error.message === 'Network Error') {
          console.log('network error');
        } else {
          logoutHandler();
        }
      } finally {
        lock.disable();
      }
    } else {
      lock.disable();
    }

    return req;
  },
  (error) => {
    if (error.response.status === 401) {
      logoutHandler();
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      logoutHandler();
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
